module.exports = __webpack_public_path__ + "img/yjb.a6799d0c.png";